<div class="modal-header">
  <h4 class="modal-title">
    Notas de Atualização - v{{ currentNote?.version || version }}
  </h4>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <!-- Estado de Loading -->
  <div class="main-content loading-state" *ngIf="loading">
    <div class="spinner-border text-primary mb-3" role="status">
      <span class="sr-only">Carregando...</span>
    </div>
    <p>Carregando notas de atualização...</p>
  </div>

  <!-- Estado de Erro -->
  <div class="main-content error-state" *ngIf="!loading && error">
    <i class="fas fa-exclamation-triangle fa-3x mb-3"></i>
    <h5>Erro ao carregar</h5>
    <p>Não foi possível carregar as notas de atualização. Tente novamente mais tarde.</p>
  </div>

  <!-- Conteúdo da nota -->
  <div class="main-content" *ngIf="!loading && !error && currentNote">
    <!-- Header da nota -->
    <div class="note-header">
      <div class="d-flex align-items-center gap-2">
        <h5 class="note-title pr-2 text-uppercase">{{ currentNote.title }}</h5>
        <span class="badge" [ngClass]="getUpdateTypeBadgeClass(currentNote.updateType)">
          {{ getUpdateTypeLabel(currentNote.updateType) }}
        </span>
      </div>
      <div class="note-meta py-2">
        <span class="note-meta-item" *ngIf="currentNote.releaseDate">
          <i class="fas fa-calendar-alt mr-1"></i>
          {{ formatDate(currentNote.releaseDate) }}
        </span>
      </div>
    </div>

    <!-- Conteúdo da nota -->
    <div class="note-content px-2">
      <markdown [data]="currentNote.description"></markdown>
    </div>
  </div>

  <!-- Estado vazio -->
  <div class="main-content empty-state" *ngIf="!loading && !error && !currentNote">
    <i class="fas fa-check-circle fa-3x mb-3"></i>
    <h5>Versão {{ version }} - Sem atualizações registradas</h5>
    <p>Esta versão não possui notas de atualização cadastradas no momento.</p>
  </div>
</div>

<div class="modal-footer standard-footer">
  <app-standard-footer-buttons
    [secondaryLabel]="'Fechar'"
    [hidePrimary]="true"
    (secondaryClick)="close()">
  </app-standard-footer-buttons>
</div>
